<template>
    <div>
        <div class="active col-12 p-3 bg-white" v-if="showLoader == 1">
            <content-placeholders :rounded="true">
                <content-placeholders-img />
                <content-placeholders-heading />
                <content-placeholders-img />
                <content-placeholders-heading />
                <content-placeholders-img />
                <content-placeholders-heading />
            </content-placeholders>
        </div>
        <!-- Enhanced Professional Sidebar with controls -->
        <div v-else>
            <div class="sub-header-container">
                <div @click="toListing" class="go-listing-div go-listing-div-left">
                    <div class="go-listing-img">
                        <img src="../../assets/Svg/close-editor.svg" alt="" />
                    </div>
                    <span>Close Editor</span>
                </div>

                <div class="title-container mb-3 mb-md-0">
                    <h1 class="main-title">{{ title }}</h1>
                </div>

                <div class="actions-container">
                    <button class="btn btn-primary" @click="saveBook" :disabled="isLoadingSaveBook">
                        <div v-if="isLoadingSaveBook" class="lds-dual-ring"></div>
                        <span v-else>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"></path>
                                <polyline points="17 21 17 13 7 13 7 21"></polyline>
                                <polyline points="7 3 7 8 15 8"></polyline>
                            </svg>
                            Save
                        </span>
                    </button>

                    <button class="btn share-btn">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <circle cx="18" cy="5" r="3"></circle>
                            <circle cx="6" cy="12" r="3"></circle>
                            <circle cx="18" cy="19" r="3"></circle>
                            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                        </svg>
                        Share
                    </button>

                    <button class="btn share-btn" @click="openPreview">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        Preview Book
                    </button>

                    <div class="opt mt-0 position-relative cursor-pointer" @click="openBookOption"
                        v-click-outside="onClickOutside">
                        <img src="../../assets/Svg/ellipse.svg" alt="" />
                        <div class="sub-setting-options edit-event-options" v-if="bookOption">
                            <ul class="mb-0 border-bottom-0 pb-0 d-block">
                                <li class="del-game">
                                    <img src="../../assets/Svg/team/team-options/edit-2.svg" alt="edit" />
                                    <p>Edit Book</p>
                                </li>
                                <li class="del-game" @click="exportToPDF">
                                    <img src="../../assets/Svg/document-text.svg" alt="save" />
                                    <p>Save PDF</p>
                                </li>
                                <li class="del-game delete-book-page" @click="deleteBook">
                                    <img src="../../assets/Svg/trash.svg" alt="delete" />
                                    <p>Delete Book</p>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
            <div class="shop-left-menu search">
                <button class="btn add-page-btn" @click="addPage">
                    Add Page
                </button>

                <!-- Pages listing with drag and drop -->
                <div class="pages-list">
                    <draggable v-model="pages" group="pages" @end="onDragEnd" handle=".page-drag-handle"
                        :move="checkMove">
                        <div v-for="(page, index) in pages" :key="page.id" class="page-item"
                            :class="{ 'active': index === currentPageIndex }" @click="switchPage(index)">
                            <div class="page-item-content">
                                <span class="page-drag-handle" v-if="!page.isNonDeletable">
                                    <img src="../../assets/Svg/grip-handle.svg" alt="" />
                                </span>
                                <span class="page-name">{{ page.name }}</span>
                                <div class="opt mt-0 position-relative cursor-pointer" @click="openPageOption"
                                    v-click-outside="onClickOutside"
                                    v-if="index === currentPageIndex && pages.length > 1 && !pages[currentPageIndex].isNonDeletable">
                                    <img src="../../assets/Svg/ellipse.svg" alt="" />
                                    <div class="sub-setting-options edit-event-options" v-if="pageOption">
                                        <ul class="mb-0 border-bottom-0 pb-0 d-block">
                                            <!-- <li class="del-game">Copy Page</li>
                                            <li class="del-game">Paste Page</li> -->
                                            <li class="del-game delete-book-page delete-book-page2"
                                                v-if="pages.length > 1 && !pages[currentPageIndex].isNonDeletable"
                                                @click="deletePage">
                                                <img src="../../assets/Svg/trash.svg" alt="delete" />
                                                <p>Delete Page</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </draggable>
                </div>
            </div>

            <!-- Modified canvas area structure -->
            <div class="shop-page-products book-center-right pl-0">
                <div class="row no-gutters">
                    <div class="col-12 col-lg-8 pl-0 pr-lg-3">
                        <div class="canvas-pagination-div">
                            <div class="canvas-area" @dragover.prevent="onDragOverCanvas" @dragleave="onDragLeaveCanvas"
                                @drop="onCanvasDrop" :class="{ 'canvas-highlight': isDraggingImage }">
                                <canvas ref="canvas" width="100%" height="100%"></canvas>
                                <!-- Add this after the canvas element -->
                                <div v-if="hasSelectedObject && !isEditingText" class="object-controls" :style="objectControlsStyle">
                                    <button class="btn-control" v-if="isTextObject" @click="editText">
                                        <img src="../../assets/Svg/edit-2.svg" alt="Edit" />
                                        <span>Edit</span>
                                    </button>
                                    <button class="btn-control" v-if="isImageObject" @click="triggerImageReplace">
                                        <img src="../../assets/Svg/replace.svg" alt="Edit" />
                                        <span>Replace</span>
                                    </button>
                                    <input type="file" ref="replaceInput" style="display: none"
                                        @change="handleImageReplace" accept="image/*">
                                    <button class="btn-control" @click="bringToFront">
                                        <img src="../../assets/Svg/tofront.svg" alt="To Front" />
                                        <span>To Front</span>
                                    </button>
                                    <button class="btn-control" @click="sendToBack">
                                        <img src="../../assets/Svg/toback.svg" alt="To Back" />
                                        <span>To Back</span>
                                    </button>
                                    <div class="remove-btn-div">
                                        <button class="btn-control btn-control-remove" @click="removeSelectedObject">
                                            <img src="../../assets/Svg/removeicon.svg" alt="Remove" />
                                            <span>Remove</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="page-controls">
                                <button class="btn btn-icon" @click="previousPage" :disabled="currentPageIndex === 0">
                                    <img src="../../assets/Svg/arrow-left-img.svg" alt="" />
                                </button>
                                <div class="pagination">
                                    <span class="page-indicator">Page {{ currentPageIndex + 1 }} of {{ pages.length
                                        }}</span>
                                </div>
                                <button class="btn btn-icon" @click="nextPage"
                                    :disabled="currentPageIndex === pages.length - 1">
                                    <img src="../../assets/Svg/arrow-right-img.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 pl-0">
                        <div class="sidebar-container">
                            <!-- Tab Navigation (Left Side) -->
                            <div class="sidebar-tabs">
                                <div class="tab-item active" data-tab="photos" @click="switchTab('photos')">
                                    <img :src="activeTab === 'photos' ? tabImages.photos.active : tabImages.photos.normal"
                                        alt="Photos" />
                                    <span>Photos</span>
                                </div>
                                <div class="tab-item" data-tab="text" @click="switchTab('text')">
                                    <img :src="activeTab === 'text' ? tabImages.text.active : tabImages.text.normal"
                                        alt="Text" />
                                    <span>Text</span>
                                </div>
                                <!-- <div class="tab-item" @click="switchTab('stickers')">
                                    <img :src="activeTab === 'stickers' ? tabImages.stickers.active : tabImages.stickers.normal" alt="Stickers" />
                                    <span>Stickers</span>
                                </div> -->
                            </div>

                            <!-- Tab Content (Right Side) -->
                            <div class="sidebar-content">
                                <!-- Photos Tab Content (Active by default) -->
                                <div class="tab-content photos-tab active">
                                    <div class="photos-tab-top">Upload photos from your PC or select from your posts.
                                    </div>
                                    <div class="upload-section">
                                        <p class="upload-text">Drop your files here</p>
                                        <p class="upload-text">OR</p>
                                        <!-- <button class="btn btn-outline-primary choose-file-btn">Choose a file</button> -->
                                        <label for="file-upload" class="file-upload-label">
                                            <span>Choose a file</span>
                                        </label>
                                        <input id="file-upload" type="file" @change="onImageUpload"
                                            class="file-upload-input" />
                                    </div>

                                    <div class="feed-section">
                                        <h4 class="feed-title">Pick from your feed</h4>

                                        <div class="photo-grid">
                                            <div class="placeholder-img" v-for="(image, index) in allPostImages"
                                                :key="index" :class="{ 'disabled': !image.loaded }" draggable="true"
                                                @dragstart="onImageDragStart(API_URL + image.image, $event)"
                                                @dragend="onImageDragEnd">
                                                <img :src="API_URL + image.image" alt="Post Image"
                                                    @click="addImageToCanvas(API_URL + image.image)"
                                                    @load="markImageLoaded(index)" />
                                                <!-- Loader appears only while loading -->
                                                <div v-if="!image.loaded" class="loader-overlay">
                                                    <div class="spinner"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Text Tab Content (Hidden initially) -->
                                <div class="tab-content text-tab">
                                    <!-- Text styles -->
                                    <div class="form-group">
                                        <label>Text:</label>
                                        <input v-model="textProps.text" type="text" id="text" placeholder="Enter text"
                                            class="form-control" />
                                    </div>
                                    <div class="form-group">
                                        <label>Font Size:</label>
                                        <div class="input-with-unit">
                                            <input v-model="textProps.fontSize" type="number" id="font-size" min="10"
                                                max="100" class="form-control" />
                                            <span class="unit">px</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Font Weight:</label>
                                        <div class="select-wrapper">
                                            <select v-model="textProps.fontWeight" id="font-weight"
                                                class="form-control">
                                                <option value="normal">Normal</option>
                                                <option value="bold">Bold</option>
                                                <option value="lighter">Lighter</option>
                                            </select>
                                            <i class="fas fa-caret-down select-icon"></i>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Text Color:</label>
                                        <div class="color-picker-wrapper">
                                            <input v-model="textProps.color" type="color" id="text-color"
                                                class="color-picker" />
                                            <span class="color-hex">{{ textProps.color.toUpperCase() }}</span>
                                        </div>
                                    </div>
                                    <button class="btn btn-primary btn-block" @click="addText">
                                        <i class="fas fa-plus-circle"></i>
                                        {{ isEditingText ? 'Update Text' : 'Add Text' }}
                                    </button>
                                </div>

                                <!-- Stickers Tab Content (Hidden initially) -->
                                <div class="tab-content stickers-tab">
                                    No Stickers Available.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Flipbook Modal -->
        <div v-if="showFlipbookModal" class="flipbook-modal">
            <!-- Close Button -->
            <button class="close-button" @click="closeFlipbookModal">
                ×
            </button>

            <div class="flipbook-book-wrapper">
                <div id="flipbook"></div>

                <!-- Page Controls -->
                <div class="flipbook-controls">
                    <button class="flip-btn prev-btn" @click="flipPrev">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                            viewBox="0 0 24 24">
                            <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                        </svg>
                    </button>
                    <button class="flip-btn next-btn" @click="flipNext">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                            viewBox="0 0 24 24">
                            <path d="M8.59 16.59 10 18l6-6-6-6-1.41 1.41L13.17 12z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { fabric } from 'fabric';
import { jsPDF } from 'jspdf';
import draggable from 'vuedraggable';
import axios from "axios";
import { PageFlip } from 'page-flip';

export default {
    name: 'PhotobookEditor',
    components: {
        draggable
    },
    data() {
        return {
            canvas: null,
            selectedShape: 'rectangle',
            hasSelectedObject: false,
            isTextObject: false,
            isImageObject: false,
            activeTextObject: null,
            isEditingText: false,
            showLoader: 1,
            pages: [],
            bookId: null,
            currentPageIndex: 0,
            isLoadingSaveBook: false,
            isLoadingDeleteBook: false,
            isLoadingDeletePage: false,
            title: "",
            canvasObjectCount: 0,
            photoCount: 0,
            shapeProps: {
                width: 100,
                height: 100,
                fill: '#4285F4', // Professional blue color
            },
            textProps: {
                text: '',
                fontSize: 30,
                fontWeight: 'normal',
                color: '#333333',
            },
            isShapeControlsCollapsed: true,
            isImageUploadCollapsed: true,
            isTextControlsCollapsed: true,
            fileName: 'No file chosen',
            initialPageZeroLoaded: false,
            showFlipbookModal: false,
            flipbookInstance: null,
            pageOption: false,
            bookOption: false,
            posts: [],
            API_URL: this.$postStorageURL,
            objectControlsStyle: {
                top: '0px',
                left: '0px'
            },
            activeTab: 'photos',
            isDraggingImage: false,
            tabImages: {
                photos: {
                    active: require('@/assets/Svg/photo-active.svg'),
                    normal: require('@/assets/Svg/photo-normal.svg')
                },
                text: {
                    active: require('@/assets/Svg/text-active.svg'),
                    normal: require('@/assets/Svg/text-normal.svg')
                },
                stickers: {
                    active: require('@/assets/Svg/sticker-active.svg'),
                    normal: require('@/assets/Svg/sticker-normal.svg')
                }
            },
        };
    },
    computed: {
        allPostImages() {
            return this.posts.flatMap(post => post.post_images || []);
        }
    },
    mounted() {
        this.fetch();
        this.bookGuid = this.$route.params.guid
        const guid = this.bookGuid;

        // First initialize the canvas
        this.$nextTick(() => {
            this.initializeCanvas();
            this.resizeCanvas();
            // Then fetch data after canvas is ready
            setTimeout(() => {
                this.fetchBookData(guid);
            }, 100);
        });

        window.addEventListener('resize', this.resizeCanvas);

        // Add event listener to update file name display
        document.getElementById('file-upload')?.addEventListener('change', function () {
            const fileName = this.files[0] ? this.files[0].name : 'No file chosen';
            document.querySelector('.file-name').textContent = fileName;
        });
    },
    methods: {
        markImageLoaded(index) {
            this.$set(this.allPostImages[index], 'loaded', true);
        },
        onImageDragStart(imageUrl, event) {
            event.dataTransfer.setData('text/plain', imageUrl);
            this.isDraggingImage = true;
        },
        onImageDragEnd() {
            this.isDraggingImage = false;
        },
        onCanvasDrop(event) {
            const imageUrl = event.dataTransfer.getData('text/plain');
            if (imageUrl) {
                this.addImageToCanvas(imageUrl);
            }
            this.isDraggingImage = false;
        },
        onDragOverCanvas() {
            this.isDraggingImage = true;
        },
        onDragLeaveCanvas() {
            this.isDraggingImage = false;
        },
        async fetch() {
            this.showLoader = 1;
            let response = await axios.get(`post/fetchPostForMyLifeBook`);
            if (response.data.statusCode == 200) {
                // this.posts = response.data.data.posts;
                // Inject `loaded: false` into each image object
                this.posts = response.data.data.posts.map(post => {
                    post.post_images = (post.post_images || []).map(img => ({
                        ...img,
                        loaded: false
                    }));
                    return post;
                });

                this.noPost = this.posts.length > 0 ? 0 : 1;
            } else {
                this.errorMessage = response.data.message;
            }
            this.showLoader = 0;
        },
        triggerImageReplace() {
            this.$refs.replaceInput.click();
        },

        handleImageReplace(event) {
            const file = event.target.files[0];
            if (!file) return;

            const activeObject = this.canvas.getActiveObject();
            if (!activeObject || activeObject.type !== 'image') return;

            try {
                // Get dimensions from current image
                const originalWidth = activeObject.getScaledWidth();
                const originalHeight = activeObject.getScaledHeight();

                // Load new image
                const reader = new FileReader();
                reader.onload = (e) => {
                    fabric.util.loadImage(e.target.result, (newImg) => {
                        // Calculate new scale to maintain original display size
                        const scaleX = originalWidth / newImg.width;
                        const scaleY = originalHeight / newImg.height;

                        activeObject.setElement(newImg);
                        activeObject.set({
                            scaleX: scaleX,
                            scaleY: scaleY,
                            dirty: true
                        });

                        this.canvas.renderAll();
                        this.clearSelection();
                    });
                };
                reader.readAsDataURL(file);
            } catch (error) {
                console.error('Error replacing image:', error);
            } finally {
                event.target.value = '';
            }
        },
        editText() {
            const activeObject = this.canvas.getActiveObject();
            if (activeObject && activeObject.type.includes('text')) {
                this.hasSelectedObject = false; // Add this to hide controls
                this.switchTab('text');
                this.textProps = {
                    text: activeObject.text,
                    fontSize: activeObject.fontSize,
                    fontWeight: activeObject.fontWeight,
                    color: activeObject.fill
                };
                this.activeTextObject = activeObject;
                this.isEditingText = true; // Add this flag
            }
        },
        updateObjectControlsPosition() {
            const activeObject = this.canvas.getActiveObject();
            if (!activeObject) return;

            const zoom = this.canvas.getZoom();
            const canvasRect = this.$refs.canvas.getBoundingClientRect();

            // Get object position relative to viewport
            const objRect = activeObject.getBoundingRect();
            const scaledTop = objRect.top * zoom + canvasRect.top;
            const scaledLeft = objRect.left * zoom + canvasRect.left;

            // Position controls at the top-right of the object
            this.objectControlsStyle = {
                top: `${scaledTop}px`, // Align with object's top
                left: `${scaledLeft + (objRect.width * zoom) + 20}px`, // 10px to the right of the object
                transform: 'none' // Remove the horizontal centering transform
            };
        },

        clearSelection() {
            this.canvas.discardActiveObject();
            this.hasSelectedObject = false;
            this.isImageObject = false;
            this.isTextObject = false;
            this.canvas.requestRenderAll();
        },

        bringToFront() {
            const obj = this.canvas.getActiveObject();
            if (obj) {
                obj.bringToFront();
                this.clearSelection();
            }
        },

        sendToBack() {
            const obj = this.canvas.getActiveObject();
            if (obj) {
                obj.sendToBack();
                this.clearSelection();
            }
        },

        removeSelectedObject() {
            const obj = this.canvas.getActiveObject();
            if (obj) {
                this.canvas.remove(obj);
                this.clearSelection();
            }
        },
        openPageOption(event) {
            event.preventDefault();
            event.stopPropagation();
            this.pageOption = !this.pageOption;
        },
        openBookOption(event) {
            event.preventDefault();
            event.stopPropagation();
            this.bookOption = !this.bookOption;
        },
        onClickOutside() {
            this.pageOption = false;
            this.bookOption = false;
        },
        closeFlipbookModal() {
            this.showFlipbookModal = false;
        },
        flipPrev() {
            if (this.flipbookInstance) {
                this.flipbookInstance.flipPrev();
            }
        },
        flipNext() {
            if (this.flipbookInstance) {
                this.flipbookInstance.flipNext();
            }
        },
        openPreview() {
            this.showFlipbookModal = true;
            this.$nextTick(() => {
                this.renderFlipbook();
            });
        },

        closePreview() {
            this.showFlipbookModal = false;
            if (this.flipbookInstance) {
                this.flipbookInstance.destroy();
                this.flipbookInstance = null;
            }
        },

        async renderFlipbook() {
            this.$nextTick(async () => {
                const container = document.getElementById('flipbook');
                if (!container) return;

                container.innerHTML = '';

                const editorCanvasWidth = this.canvas.getWidth();
                const editorCanvasHeight = this.canvas.getHeight();

                // Important: Flipbook container full size
                const bookWidth = editorCanvasWidth * 2; // Full book is 2 pages side by side
                const bookHeight = editorCanvasHeight;

                // Each page is HALF of book width
                const pageWidth = bookWidth / 2;
                const pageHeight = bookHeight;

                const pages = [];

                for (let i = 0; i < this.pages.length; i++) {
                    const page = this.pages[i];

                    const canvasEl = document.createElement('canvas');
                    canvasEl.width = pageWidth;
                    canvasEl.height = pageHeight;

                    const fabricPreview = new fabric.StaticCanvas(canvasEl);

                    if (page.canvasObjects) {
                        await new Promise((resolve) => {
                            fabricPreview.loadFromJSON(page.canvasObjects, () => {
                                // No scaling applied here
                                fabricPreview.renderAll();
                                resolve();
                            });
                        });
                    }

                    const pageDiv = document.createElement('div');
                    pageDiv.className = 'page';
                    pageDiv.style.width = `${pageWidth}px`;
                    pageDiv.style.height = `${pageHeight}px`;
                    pageDiv.appendChild(canvasEl);

                    // Add the first-page class to the first page
                    if (i === 0) {
                        pageDiv.classList.add('first-page');
                    }

                    // Create and append the page number element
                    const pageNumberDiv = document.createElement('div');
                    pageNumberDiv.className = 'page-number';
                    pageNumberDiv.innerText = i + 1;  // Page numbers start from 1
                    pageDiv.appendChild(pageNumberDiv);

                    container.appendChild(pageDiv);
                    pages.push(pageDiv);
                }

                // Now init PageFlip
                this.flipbookInstance = new PageFlip(container, {
                    width: pageWidth,
                    height: pageHeight,
                    size: 'fixed',
                    showCover: true,    // Important: treat first page as cover
                    maxShadowOpacity: 0.5,
                    useMouseEvents: true,
                    mobileScrollSupport: false,
                    flippingTime: 700
                });

                this.flipbookInstance.loadFromHTML(pages);

                // Adjust flipbook-wrapper size dynamically
                const flipbookWrapper = document.querySelector('.flipbook-book-wrapper');

                const adjustWrapperWidth = (pageIndex) => {
                    const totalPages = this.pages.length;
                    if (pageIndex === 0 || pageIndex === totalPages - 1) {
                        // First or last page - single page
                        flipbookWrapper.style.width = `${pageWidth}px`;
                        container.classList.add('single-page');  // Add the single-page class for single page view
                        container.classList.remove('double-page');
                    } else {
                        // Middle pages - double page spread
                        flipbookWrapper.style.width = `${bookWidth}px`;
                        container.classList.add('double-page');  // Add the double-page class for double page view
                        container.classList.remove('single-page');
                    }
                };

                // On first initialization, let PageFlip render the pages first
                setTimeout(() => {
                    // Now adjust the width of the wrapper based on the current page
                    adjustWrapperWidth(0);  // First page should be a single page (canvas width)

                    // Handle the flip event dynamically for other pages
                    this.flipbookInstance.on('flip', (e) => {
                        const currentPage = e.data;
                        adjustWrapperWidth(currentPage);
                    });
                }, 100);  // Allow time for initial rendering of pages

                // Set the wrapper height
                flipbookWrapper.style.height = `${bookHeight}px`;
            });
        },

        toListing() {
            this.$router.push({ name: "PhotoBookListing" });
        },
        async saveBook() {
            this.isLoadingSaveBook = true;
            try {
                // Save current page state
                if (this.canvas) {
                    const canvasJSON = JSON.parse(JSON.stringify(this.canvas.toJSON()));
                    canvasJSON.canvasWidth = this.canvas.getWidth();
                    canvasJSON.canvasHeight = this.canvas.getHeight();
                    this.pages[this.currentPageIndex].canvasObjects = canvasJSON;
                }

                // Prepare pages data with correct page numbers
                const backCover = this.pages[this.pages.length - 1];
                const backCoverOriginalPageNumber = backCover.pageNumber || this.pages.length; // Fallback to array length if undefined
                const newPages = this.pages.slice(0, -1).filter(page => !page.pageNumber);
                const newPagesCount = newPages.length;

                const pagesData = this.pages.map(page => {
                    if (page === backCover) {
                        // Back cover gets the highest page_number
                        return {
                            page_number: backCoverOriginalPageNumber + newPagesCount,
                            content_json: JSON.stringify(page.canvasObjects || { objects: [] })
                        };
                    } else if (!page.pageNumber) {
                        // New pages get sequential numbers before back cover's original
                        const indexInNewPages = newPages.indexOf(page);
                        return {
                            page_number: backCoverOriginalPageNumber + indexInNewPages,
                            content_json: JSON.stringify(page.canvasObjects || { objects: [] })
                        };
                    } else {
                        // Existing pages retain their original page_number
                        return {
                            page_number: page.pageNumber,
                            content_json: JSON.stringify(page.canvasObjects || { objects: [] })
                        };
                    }
                });

                const payload = {
                    book_id: this.bookId,
                    pages: pagesData
                };

                const response = await axios.post(
                    process.env.VUE_APP_API_URL + 'lifebook/createPage',
                    payload,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (response.data.statusCode === 200) {
                    console.log('Book saved successfully');
                }
            } catch (error) {
                console.error('Error saving book:', error);
            } finally {
                this.isLoadingSaveBook = false;
            }
        },
        async deleteBook() {
            this.isLoadingDeleteBook = true;
            try {

                // Create the request payload
                const payload = {
                    guid: this.bookGuid,
                };

                const response = await axios.post(
                    process.env.VUE_APP_API_URL + 'lifebook/deleteBook',
                    payload
                );

                if (response.data.statusCode === 200) {
                    this.$router.push({ name: "PhotoBookListing" });
                }
            } catch (error) {
                console.error('Error deleting book:', error);
            } finally {
                this.isLoadingDeleteBook = false;
            }
        },
        async deletePage() {
            if (this.pages.length <= 1 || this.pages[this.currentPageIndex].isNonDeletable) return;

            const currentPage = this.pages[this.currentPageIndex];

            // Check if page has a pageNumber (exists in the backend)
            if (currentPage.pageNumber) {
                // This page exists in the backend, so we need to delete via API
                this.isLoadingDeletePage = true;
                try {
                    const payload = {
                        book_id: this.bookId,
                        page_number: currentPage.pageNumber
                    };

                    const response = await axios.post(
                        process.env.VUE_APP_API_URL + 'lifebook/deletePage',
                        payload
                    );

                    if (response.data.statusCode === 200) {
                        // Continue with deletion from frontend after API success
                        this.deletePageFromFrontend();
                    }
                } catch (error) {
                    console.error('Error deleting page:', error);
                } finally {
                    this.isLoadingDeletePage = false;
                }
            } else {
                // Page doesn't exist in backend, just delete it from frontend
                this.deletePageFromFrontend();
            }
        },

        deletePageFromFrontend() {
            this.canvas.clear();

            // Remove page from array
            this.pages.splice(this.currentPageIndex, 1);

            // Adjust current page index
            if (this.currentPageIndex >= this.pages.length) {
                this.currentPageIndex = this.pages.length - 1;
            }

            // Update page names
            this.pages.forEach((page, idx) => {
                page.name = `Page ${idx + 1}`;
            });

            // Load new current page's data
            const newPage = this.pages[this.currentPageIndex];
            if (newPage?.canvasObjects) {
                this.canvas.loadFromJSON(newPage.canvasObjects, () => {
                    this.canvas.renderAll();
                    this.updateCanvasCount();
                });
            } else {
                this.canvas.renderAll();
                this.updateCanvasCount();
            }
            this.updatePageNames();
        },

        checkMove(e) {
            const draggedPage = e.draggedContext.element;

            // Additional checks for front/back cover based on index
            const draggedIndex = this.pages.findIndex(page => page.id === draggedPage.id);
            const isFirstOrLast = draggedIndex === 0 || draggedIndex === this.pages.length - 1;

            // Check if the page is non-deletable OR is first/last page
            if (draggedPage.isNonDeletable || isFirstOrLast) {
                return false; // Prevent drag
            }

            // Additional check - ensure we're not trying to move a page to first or last position
            const newIndex = e.draggedContext.futureIndex;
            if (newIndex === 0 || newIndex === this.pages.length - 1) {
                return false;
            }

            return true; // Allow drag
        },

        async fetchBookData(guid) {
            this.showLoader = 1;
            const formData = new FormData();
            formData.append("guid", guid);
            try {
                const response = await axios.post(
                    process.env.VUE_APP_API_URL + "lifebook/show",
                    formData
                );

                if (response.data.statusCode === 200) {
                    this.bookData = response.data.data;
                    this.title = this.bookData.title;
                    this.bookId = this.bookData.id;

                    // Map API pages to our format with proper naming and draggable settings
                    this.pages = this.bookData.pages.map((apiPage, index, arr) => {
                        const isFirst = index === 0;
                        const isLast = index === arr.length - 1;

                        // Determine page name
                        let name;
                        if (isFirst) {
                            name = 'Front Cover';
                        } else if (isLast) {
                            name = 'Back Cover';
                        } else {
                            name = `Page ${index}`; // Shows "Page 1" for index 1, "Page 2" for index 2, etc.
                        }

                        // Parse canvas content
                        let canvasContent;
                        try {
                            canvasContent = apiPage.content_json ?
                                JSON.parse(apiPage.content_json) :
                                { objects: [] };
                        } catch (error) {
                            console.error("Error parsing JSON for page", apiPage.page_number, error);
                            canvasContent = { objects: [] };
                        }

                        const photoCount = canvasContent.objects?.filter(obj => obj.type === 'image').length || 0;

                        return {
                            id: apiPage.id,
                            name: name,
                            pageNumber: apiPage.page_number,
                            canvasObjects: canvasContent,
                            isNonDeletable: isFirst || isLast || apiPage.is_non_deletable === 1,
                            objectCount: canvasContent.objects?.length || 0,
                            photoCount: photoCount
                        };
                    });

                    this.$nextTick(() => {
                        if (!this.canvas) this.initializeCanvas();
                        setTimeout(() => this.switchPage(0), 100);
                    });
                }
            } catch (error) {
                console.error("Failed to fetch data:", error);
            } finally {
                this.showLoader = 0;
            }
        },
        updateCanvasCount() {
            const objects = this.canvas.getObjects();
            this.canvasObjectCount = objects.length;

            // Count photos
            this.photoCount = objects.filter(obj => obj instanceof fabric.Image).length;

            // Update current page stats
            if (this.pages[this.currentPageIndex]) {
                this.pages[this.currentPageIndex].objectCount = this.canvasObjectCount;
                this.pages[this.currentPageIndex].photoCount = this.photoCount;
            }
        },

        getPageInfoText(page) {
            const photos = page.photoCount || 0;
            return `${photos} Photo${photos !== 1 ? 's' : ''}`;
        },

        addPage() {
            // First save the current page state
            if (this.canvas) {
                const canvasJSON = JSON.parse(JSON.stringify(this.canvas.toJSON()));
                canvasJSON.canvasWidth = this.canvas.getWidth();
                canvasJSON.canvasHeight = this.canvas.getHeight();
                this.pages[this.currentPageIndex].canvasObjects = canvasJSON;
            }

            // Create a new empty page
            const newPage = {
                id: Date.now(),
                name: 'New Page',
                canvasObjects: { objects: [] }, // Initialize with empty objects array
                isNonDeletable: false
            };

            // Always insert before the last page (back cover)
            if (this.pages.length >= 1 && this.pages[this.pages.length - 1].isNonDeletable) {
                this.pages.splice(this.pages.length - 1, 0, newPage);
            } else {
                this.pages.push(newPage);
            }

            this.updatePageNames();

            // Clear the canvas before switching
            this.canvas.clear();
            this.canvas.renderAll();

            // Set current page index to the new page
            const newPageIndex = this.pages.indexOf(newPage);
            this.currentPageIndex = newPageIndex;

            // Reset counts
            this.updateCanvasCount();
        },

        updatePageNames() {
            this.pages.forEach((page, index) => {
                const isFirst = index === 0;
                const isLast = index === this.pages.length - 1;

                if (isFirst) page.name = 'Front Cover';
                else if (isLast) page.name = 'Back Cover';
                else page.name = `Page ${index}`;
            });
        },

        previousPage() {
            if (this.currentPageIndex > 0) {
                this.switchPage(this.currentPageIndex - 1);
            }
        },

        nextPage() {
            if (this.currentPageIndex < this.pages.length - 1) {
                this.switchPage(this.currentPageIndex + 1);
            }
        },

        addImageToCanvas(imageUrl) {
            if (!this.canvas) {
                this.$nextTick(() => {
                    this.initializeCanvas();
                    setTimeout(() => this.addImageToCanvas(imageUrl), 100);
                });
                return;
            }
            fabric.Image.fromURL(imageUrl, (img) => {
                img.set({
                    left: 100,
                    top: 100,
                    scaleX: 0.5,
                    scaleY: 0.5
                });
                this.canvas.add(img);
                this.canvas.setActiveObject(img);
                this.canvas.renderAll();
            });
        },

        switchTab(tabName) {
            this.activeTab = tabName;
            // Remove active class from all tabs
            document.querySelectorAll('.tab-item').forEach(tab => tab.classList.remove('active'));
            // Add active class to target tab
            const targetTab = document.querySelector(`[data-tab="${tabName}"]`);
            if (targetTab) targetTab.classList.add('active');

            // Hide all tab contents
            document.querySelectorAll('.tab-content').forEach(content => {
                content.classList.remove('active');
            });
            // Show selected tab content
            document.querySelector(`.${tabName}-tab`).classList.add('active');
        },

        // Also modify your switchPage method to better handle the JSON:

        switchPage(index) {
            if (!this.canvas) {
                this.initializeCanvas();
                setTimeout(() => this.switchPage(index), 100);
                return;
            }

            // Save current page before switching
            if (this.currentPageIndex >= 0 && this.currentPageIndex < this.pages.length) {
                try {
                    const canvasJSON = JSON.parse(JSON.stringify(this.canvas.toJSON()));
                    canvasJSON.canvasWidth = this.canvas.getWidth();
                    canvasJSON.canvasHeight = this.canvas.getHeight();
                    this.pages[this.currentPageIndex].canvasObjects = canvasJSON;
                } catch (e) {
                    console.error("Error saving current page state:", e);
                }
            }

            // Initial page 0 load handling
            if (index === 0 && !this.initialPageZeroLoaded && this.bookData?.pages?.length > 0) {
                try {
                    const raw = this.bookData.pages[0].content_json;
                    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
                    if (parsed?.objects?.length) {
                        this.pages[0].canvasObjects = parsed;
                        this.initialPageZeroLoaded = true;
                    }
                } catch (e) {
                    console.error("Error parsing initial page 0:", e);
                }
            }

            this.currentPageIndex = index;
            this.pages.forEach((p, i) => p.active = i === index);
            this.canvas.clear();

            const data = this.pages[index].canvasObjects;
            if (!data?.objects?.length) {
                return this.canvas.renderAll();
            }

            this.canvas.loadFromJSON(data, () => {
                const savedW = data.canvasWidth || this.standardCanvasWidth;
                const savedH = data.canvasHeight || this.standardCanvasHeight;
                const actualW = this.canvas.getWidth();
                const actualH = this.canvas.getHeight();

                const scaleX = actualW / savedW;
                const scaleY = actualH / savedH;
                const scale = Math.min(scaleX, scaleY); // uniform scale

                this.canvas.getObjects().forEach(obj => {
                    obj.scaleX *= scale;
                    obj.scaleY *= scale;
                    obj.left *= scale;
                    obj.top *= scale;
                    obj.setCoords();
                });

                this.canvas.renderAll();
                this.updateCanvasCount();
            });
        },

        removeCurrentPage() {
            // Prevent deletion if page is non-deletable or only one page remains
            if (this.pages.length <= 1 || this.pages[this.currentPageIndex].isNonDeletable) {
                return;
            }

            // Clear the canvas first to prevent data issues
            this.canvas.clear();
            this.canvas.renderAll();

            // Get the index to be removed
            const indexToRemove = this.currentPageIndex;

            // Remove the page
            this.pages.splice(indexToRemove, 1);

            // Determine new index to switch to
            const newIndex = indexToRemove >= this.pages.length ? this.pages.length - 1 : indexToRemove;

            // Update names for all remaining pages to ensure sequential naming
            this.pages.forEach((page, idx) => {
                page.name = `Page ${idx + 1}`;
            });

            // Set the current page index and then switch to it
            this.currentPageIndex = newIndex;

            // Load the canvas data for the new current page
            if (this.pages[newIndex].canvasObjects && this.pages[newIndex].canvasObjects.objects) {
                this.canvas.loadFromJSON(this.pages[newIndex].canvasObjects, () => {
                    this.canvas.renderAll();
                    this.updateCanvasCount();
                });
            } else {
                this.updateCanvasCount();
            }
        },

        onDragEnd() {
            this.updatePageNames();

            // Reassign page numbers sequentially (1, 2, 3, ...)
            this.pages.forEach((page, index) => {
                const isFirst = index === 0;
                const isLast = index === this.pages.length - 1;

                if (isFirst) {
                    page.pageNumber = 1; // Front cover
                } else if (isLast) {
                    page.pageNumber = this.pages.length; // Back cover
                } else {
                    page.pageNumber = index + 1;
                }
            });

            // Update current page index if needed
            const activePage = this.pages.findIndex(page => page.active);
            if (activePage !== -1) {
                this.currentPageIndex = activePage;
            }
        },

        async exportToPDF() {
            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'px',
                format: [this.canvas.width, this.canvas.height],
            });

            // Save current page state
            this.pages[this.currentPageIndex].canvasObjects = this.canvas.toJSON();

            // Create PDF for each page
            for (let i = 0; i < this.pages.length; i++) {
                if (i > 0) pdf.addPage();

                // Create temporary canvas for export
                const tempCanvas = document.createElement('canvas');
                tempCanvas.width = this.canvas.width;
                tempCanvas.height = this.canvas.height;
                const tempFabricCanvas = new fabric.Canvas(tempCanvas);

                // Load page data to temporary canvas
                if (this.pages[i].canvasObjects.objects) {
                    await new Promise(resolve => {
                        tempFabricCanvas.loadFromJSON(this.pages[i].canvasObjects, () => {
                            tempFabricCanvas.renderAll();
                            resolve();
                        });
                    });
                }

                // Add to PDF
                const dataUrl = tempFabricCanvas.toDataURL({
                    format: 'png',
                    quality: 1,
                });

                pdf.addImage(dataUrl, 'PNG', 0, 0, tempCanvas.width, tempCanvas.height);
            }

            // Get filename from title input or default to 'photobook'
            const fileName = this.title.trim() || 'photobook';
            pdf.save(`${fileName}.pdf`);
        },
        resizeCanvas() {
            const canvas = this.$refs.canvas;
            if (!canvas) return;

            const container = canvas.parentElement;

            // Get actual pixel dimensions
            const width = container.clientWidth;
            const height = container.clientHeight;

            // Set the canvas element dimensions
            canvas.width = width;
            canvas.height = height;

            // If Fabric.js canvas is initialized, update its dimensions too
            if (this.canvas) {
                this.canvas.setWidth(width);
                this.canvas.setHeight(height);
                this.canvas.renderAll();
            }
        },
        toggleSection(section) {
            if (section === 'shapeControls') {
                this.isShapeControlsCollapsed = !this.isShapeControlsCollapsed;
            } else if (section === 'imageUpload') {
                this.isImageUploadCollapsed = !this.isImageUploadCollapsed;
            } else if (section === 'textControls') {
                this.isTextControlsCollapsed = !this.isTextControlsCollapsed;
            }
        },
        updateShape() {
            if (this.selectedShape === 'rectangle') {
                this.shapeProps.width = 100;
                this.shapeProps.height = 100;
            } else if (this.selectedShape === 'circle') {
                this.shapeProps.width = 100;
                this.shapeProps.height = 100;
            } else if (this.selectedShape === 'triangle') {
                this.shapeProps.width = 100;
                this.shapeProps.height = 100;
            }
        },
        createShape(type) {
            switch (type) {
                case 'rectangle':
                    return new fabric.Rect({
                        left: 100,
                        top: 100,
                        width: this.shapeProps.width,
                        height: this.shapeProps.height,
                        fill: this.shapeProps.fill,
                        hasControls: true,
                        lockScalingX: false,
                        lockScalingY: false,
                    });
                case 'circle':
                    return new fabric.Circle({
                        left: 150,
                        top: 150,
                        radius: this.shapeProps.width / 2,
                        fill: this.shapeProps.fill,
                        hasControls: true,
                        lockScalingX: true,
                        lockScalingY: true,
                    });
                case 'triangle':
                    return new fabric.Triangle({
                        left: 200,
                        top: 200,
                        width: this.shapeProps.width,
                        height: this.shapeProps.height,
                        fill: this.shapeProps.fill,
                        hasControls: true,
                    });
                default:
                    return null;
            }
        },
        addShape() {
            if (!this.canvas) {
                // Re-initialize canvas if needed
                this.$nextTick(() => {
                    this.initializeCanvas();
                    // Try adding the shape again after initialization
                    setTimeout(() => this.addShape(), 100);
                });
                return;
            }

            const shape = this.createShape(this.selectedShape);
            if (shape) {
                this.canvas.add(shape);
                this.canvas.renderAll();
            }
        },
        initializeCanvas() {
            if (!this.$refs.canvas) {
                return;
            }

            if (this.canvas) {
                this.canvas.dispose();
            }

            const container = this.$refs.canvas.parentElement;
            const width = container.clientWidth;
            const height = container.clientHeight;

            this.standardCanvasWidth = width;
            this.standardCanvasHeight = height;

            this.canvas = new fabric.Canvas(this.$refs.canvas, {
                width,
                height
            });

            const updateSelectionState = () => {
                const activeObject = this.canvas.getActiveObject();
                this.hasSelectedObject = !!activeObject;

                if (activeObject) {
                    this.isTextObject = activeObject.type === 'textbox' || activeObject.type === 'text';
                    this.isImageObject = activeObject.type === 'image';
                    this.isEditingText = false;
                    this.activeTextObject = null;
                    this.updateObjectControlsPosition();
                } else {
                    this.isTextObject = false;
                    this.isImageObject = false;
                }
            };

            this.canvas.on('selection:created', updateSelectionState);
            this.canvas.on('selection:updated', updateSelectionState);
            this.canvas.on('selection:cleared', () => {
                this.hasSelectedObject = false;
                this.isTextObject = false;
                this.isImageObject = false;
            });

            this.canvas.on('object:moving', () => {
                this.hideObjectControls();
                this.updateObjectControlsPosition();
            });
            this.canvas.on('object:scaling', () => {
                this.hideObjectControls();
                this.updateObjectControlsPosition();
            });
            this.canvas.on('object:rotating', () => {
                this.hideObjectControls();
                this.updateObjectControlsPosition();
            });

            this.canvas.on('mouse:up', () => {
                const activeObject = this.canvas.getActiveObject();
                if (activeObject) {
                    this.showObjectControls();
                    this.updateObjectControlsPosition();
                }
            });
        },
        hideObjectControls() {
            this.hasSelectedObject = false;
        },
        showObjectControls() {
            this.hasSelectedObject = true;
        },
        onImageUpload(event) {
            if (!this.canvas) {
                return;
            }

            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const imgElement = new Image();
                    imgElement.src = e.target.result;

                    imgElement.onload = () => {
                        const imgInstance = new fabric.Image(imgElement, {
                            left: 100,
                            top: 100,
                            scaleX: 0.5,
                            scaleY: 0.5,
                        });
                        this.canvas.add(imgInstance);
                        this.canvas.renderAll();
                    };
                };

                reader.readAsDataURL(file);
            }
        },

        addText() {
            if (!this.canvas) {
                // Re-initialize canvas if needed
                this.$nextTick(() => {
                    this.initializeCanvas();
                    // Try adding the text again after initialization
                    setTimeout(() => this.addText(), 100);
                });
                return;
            }

            if (this.activeTextObject) {
                // Update existing text
                this.activeTextObject.set({
                    text: this.textProps.text,
                    fontSize: Number(this.textProps.fontSize),
                    fontWeight: this.textProps.fontWeight,
                    fill: this.textProps.color
                });

                // Clear selection and reset state
                this.canvas.discardActiveObject();
                this.canvas.renderAll();
                this.hasSelectedObject = false;
                this.isEditingText = false;
                this.activeTextObject = null;
            } else {
                // Add new text
                const text = new fabric.Text(this.textProps.text, {
                    left: 100,
                    top: 100,
                    fontSize: Number(this.textProps.fontSize),
                    fontWeight: this.textProps.fontWeight,
                    fill: this.textProps.color
                });
                this.canvas.add(text);
                this.canvas.renderAll();
            }
            // Reset input fields to default values
            this.textProps.text = '';
            this.textProps.fontSize = 30;
            this.textProps.fontWeight = 'normal';
            this.textProps.color = '#333333';
        },
    },
};
</script>

<style scoped>
/* Flex container for main layout */
.photobook-container {
    display: flex;
    justify-content: space-between;
    height: 100vh;
}

/* Enhanced professional sidebar styling */
.shop-left-menu {
    padding: 10px;
    height: calc(100vh - 130px);
}

.add-page-btn {
    background-color: #F0F2F5;
    padding: 4px 10px !important;
    height: 35px !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #254C72 !important;
    border-radius: 5px !important;
    border: 0.5px solid #CFD7E0 !important;
    width: 100% !important;
}

/* Page listing styling */
.pages-list {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
}

.page-item {
    height: 50px;
    padding: 8px 10px;
    margin-bottom: 5px;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    border-radius: 5px;
}

.page-item:hover {
    background-color: #E5F2FE;
}

.page-item.active {
    background-color: #E5F2FE;
}

.page-item-content {
    display: flex;
    align-items: center;
    height: 34px;
}

.page-drag-handle {
    cursor: grab;
    color: #607d8b;
    /* Make it darker and more visible */
    margin-right: 10px;
    font-size: 16px;
    /* Increase size */
    padding: 5px;
    /* Add some padding */
    display: flex;
    align-items: center;
}

.page-drag-handle:hover {
    color: #455a64;
    /* Darker on hover */
    background-color: #f0f0f0;
    /* Light background on hover */
    border-radius: 3px;
}

.page-name {
    flex-grow: 1;
    font-size: 14px;
    font-weight: 500;
    color: #455a64;
}

.page-info {
    font-size: 12px;
    color: #90a4ae;
}

/* Panel components */
.panel {
    margin-bottom: 2px;
    border-bottom: 1px solid #f0f0f0;
}

.panel-header {
    cursor: pointer;
    padding: 16px 10px;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: background-color 0.2s ease;
}

.panel-header:hover {
    background-color: #f8f9fa;
}

.panel-title {
    margin: 0;
    color: #557491 !important;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
}

.panel-icon {
    margin-right: 10px;
    color: #4285F4;
    font-size: 18px;
}

.panel-toggle {
    color: #90a4ae;
    font-size: 14px;
}

.panel-body {
    padding: 20px;
    background-color: #fafbfc;
    border-top: 1px solid #f0f0f0;
}

.text-tab select,
.text-tab input {
    height: 40px !important;
    background-color: #F0F2F5 !important;
    color: #557491 !important;
}

/* Form styling */
.form-group {
    margin-bottom: 16px;
}

.form-row {
    display: flex;
    margin: 0 -8px 16px -8px;
}

.form-group.half {
    width: 50%;
    padding: 0 8px;
}

label {
    display: block;
    margin-bottom: 3px;
    color: #254C72 !important;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
}

.form-control {
    width: 100%;
    padding: 10px 12px;
    border-radius: 4px;
    border: 1px solid #dce1e6;
    font-size: 14px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    background-color: #fff;
}

.form-control:focus {
    border-color: #4285F4;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
    outline: none;
}

.form-control::placeholder {
    color: #b0bec5;
}

/* Select styling */
.select-wrapper {
    position: relative;
}

.select-wrapper select {
    appearance: none;
    padding-right: 30px;
}

.select-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #90a4ae;
    pointer-events: none;
}

/* Color picker styling */
.color-picker-wrapper {
    display: flex;
    align-items: center;
}

.color-hex {
    margin-left: 12px;
    font-size: 14px;
    font-weight: 400;
    color: #254C72;
}

/* Input with unit */
.input-with-unit {
    position: relative;
}

.input-with-unit .form-control {
    padding-right: 30px;
}

.unit {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #90a4ae;
    font-size: 12px;
}

/* Button styling */
.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-primary {
    background-color: #4285F4;
    color: white;
}

.btn-primary:hover {
    background-color: #3367d6;
}

.btn-block {
    width: 100%;
}

.btn i {
    margin-right: 8px;
}

/* File upload styling */
.file-upload-container {
    display: flex;
    flex-direction: column;
}

.file-upload-label {
    height: 35px;
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    background-color: #E5F2FE;
    color: #546e7a;
    border-radius: 5px;
    cursor: pointer;
    border: 0.5px solid #CCE6FD;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    transition: background-color 0.2s ease;
}

.file-upload-label:hover {
    background-color: #e4e7e9;
}

.file-upload-label i {
    margin-right: 8px;
    font-size: 16px;
}

.file-upload-input {
    display: none;
}

.file-name {
    font-size: 13px;
    color: #607d8b;
    margin-top: 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* New container to wrap both the header and canvas area */
.canvas-container {
    width: 100% !important;
    height: 100% !important;
}

/* Keep your existing canvas-area styles but without flex-direction changes */
.canvas-area {
    width: 80% !important;
    height: calc(100vh - 280px) !important;
    margin: 0 auto;
    border: 2px solid transparent;
    transition: border 0.3s ease;
}

.canvas-area.canvas-highlight {
    border: 2px dashed #3498db;
    border-radius: 8px;
}

canvas {
    background: #fff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    width: 100% !important;
    height: 100% !important;
}

.page-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background-color: #fff;
    height: 40px !important;
    width: 300px !important;
    margin: 0 auto !important;
    border-radius: 5px;
    padding: 14px;
}

.right-controls-form {
    background-color: #ffffff;
    padding: 16px;
    height: calc(100vh - 162px);
    overflow: hidden;
    overflow-y: auto;
    border-radius: 8px;
}

.book-save-btn {
    width: 90px;
}

.book-preview-btn {
    min-width: 75px !important;
}

.book-delete-btn {
    width: 98px;
    background-color: #FF5B66;
    color: #FFFFFF;
}

.book-delete-btn:hover {
    background-color: #fa1424;
}

.remove-object-btn {
    background-color: #FF5B66;
    color: #FFFFFF;
}

.remove-object-btn:hover {
    background-color: #fa1424;
}

.flipbook-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    overflow: hidden;
}

.close-button {
    position: absolute;
    top: 20px;
    right: 30px;
    font-size: 24px;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 1001;
}

.flipbook-book-wrapper {
    width: 85vw;
    height: calc(100vh - 280px);
    position: relative;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#flipbook {
    width: 100%;
    height: 100%;
    display: flex;
    gap: 0;
    /* no space between pages */
    background-color: white;
}

.page {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
}

.page canvas {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
}

/* In the style section */
.flip-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 9999;
    background-color: white;
    border: 1px solid #ccc;
    font-size: 28px;
    width: 35px;
    height: 35px;
    cursor: pointer;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: background 0.3s;
}

.flip-btn:hover {
    background-color: #f0f0f0;
}

.prev-btn {
    left: -4%;
}

.next-btn {
    right: -4%;
}

#flipbook.double-page::before {
    content: "";
    position: absolute;
    left: 50%;
    top: 0;
    height: 100%;
    width: 2px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.5);
    z-index: 5;
    pointer-events: none;
}

/* Remove box-shadow for single page view */
#flipbook.single-page::before {
    box-shadow: none;
}

.main-title {
    font-size: 24px;
    font-weight: 400;
    color: #FFFFFF;
    margin: 0;
}

.subtitle {
    font-size: 14px;
    color: #666;
    margin: 0;
}

.btn svg {
    margin-right: 5px;
}

.overflow-menu {
    padding: 6px;
    border-radius: 4px;
    background: none;
    border: none;
    cursor: pointer;
    margin-left: 12px;
}

.overflow-menu:hover {
    background-color: #f0f0f0;
}

.share-btn {
    background-color: #F0F2F5 !important;
    height: 35px !important;
    padding: 4px 10px !important;
    border-radius: 5px !important;
}

.canvas-pagination-div {
    height: calc(100vh - 148px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 16px;
}

/* Right Sidebar Container */
.sidebar-container {
    display: flex;
    height: calc(100vh - 130px);
    background-color: #f8f9fa;
    border-left: 1px solid #e0e0e0;
}

/* Tab Navigation (Left Side) */
.sidebar-tabs {
    width: 70px;
    background-color: #CFD7E0;
    display: flex;
    flex-direction: column;
}

.tab-item {
    height: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #666;
    cursor: pointer;
    transition: background-color 0.2s;
}

.tab-item:hover {
    background-color: #e2e8f0;
}

.tab-item.active {
    background-color: #B9C6D3;
    border-bottom: none !important;
}

.tab-item i {
    font-size: 20px;
    margin-bottom: 5px;
}

.tab-item span {
    font-size: 14px;
    font-weight: 400;
    color: #557491;
}

.tab-item.active span {
    color: #333333;
}

/* Tab Content (Right Side) */
.sidebar-content {
    background-color: #B9C6D3;
    flex: 1;
    padding: 15px;
    height: calc(100vh - 130px);
    overflow: hidden;
    scrollbar-gutter: stable
}

.sidebar-content:hover {
    overflow-y: auto;
}

.tab-content {
    display: none;
}

.tab-content.active {
    display: block;
}

/* Photos Tab */
.upload-section {
    background-color: #F0F2F5;
    border-radius: 8px;
    border: 1px dashed #7FC0F9;
    padding: 30px 20px;
    text-align: center;
    margin: 20px 0;
}

.upload-text {
    color: #557491;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
}

.choose-file-btn {
    background-color: transparent;
    border: 1px solid #4285f4;
    color: #4285f4;
    padding: 6px 12px;
    font-size: 13px;
    border-radius: 4px;
    cursor: pointer;
}

.choose-file-btn:hover {
    background-color: rgba(66, 133, 244, 0.1);
}

.feed-title {
    font-size: 20px;
    font-weight: 400;
    color: #254C72;
    margin-bottom: 10px;
}

.feed-date {
    font-size: 16px;
    font-weight: 400;
    color: #254C72;
    margin: 15px 0;
}

.photo-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}

.placeholder-img {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;
    /* height: 100%; */
    color: #ccc;
    font-size: 24px;
    border-radius: 8px;
    overflow: hidden;
    cursor: grab;
}

/* Text Styles Tab */
.style-heading {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin: 15px 0 10px;
}

.text-style-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
}

.text-style-sample {
    width: 30px;
    font-size: 16px;
    color: #333;
}

.text-style-label {
    flex: 1;
    font-size: 14px;
    color: #333;
}

.text-style-size {
    color: #999;
    font-size: 12px;
}

/* Color Styles */
.color-style-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
}

.color-dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 10px;
}

.color-label {
    font-size: 14px;
    color: #333;
}

/* Stickers Tab */
.stickers-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.sticker-item {
    aspect-ratio: 1/1;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    cursor: pointer;
}

.stickers-tab {
    text-align: center;
    color: #254C72;
    font-size: 14px;
    font-weight: 400;
}

.text-tab input.color-picker {
    width: 40px;
    height: 40px !important;
    padding: 0 !important;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background: none !important;
}

.photos-tab-top {
    color: #254C72;
    font-size: 14px;
    font-weight: 400;
}

.book-center-right {
    height: calc(100vh - 130px) !important;
    overflow: hidden;
    overflow-y: auto;
    padding: 0 !important;
}

.object-controls {
    position: fixed;
    /* top: 16px;
    right: 0; */
    display: flex;
    flex-direction: column;
    gap: 5px;
    background: #FFFFFF;
    padding: 13px 8px;
    border-radius: 5px;
    box-shadow: 0px 4px 15px 0px #00000040;
    z-index: 1000;
}

.btn-control {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}

.remove-btn-div {
    border-top: 1px solid #CFD7E0;
    padding-top: 7px !important;
}

.btn-control span {
    font-size: 14px;
    font-weight: 400;
    color: #254C72;
}

.btn-control-remove span {
    color: #FF5B66 !important;
}

.btn-control:hover {
    background: #f0f0f0;
    border-radius: 5px;
}

.btn-control img {
    width: 20px;
    height: 20px;
}

.placeholder-img img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
    object-position: center;
}

.placeholder-img.disabled {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.6;
}

.loader-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.spinner {
    width: 30px;
    height: 30px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@media screen and (max-width: 767.98px) {
  .books-grid {
    display: block !important;
  }

  .canvas-area,
  .page-controls {
    width: 100% !important;
  }

  .sidebar-container {
    margin-top: 16px;
  }

  .shop-left-menu,
  .book-center-right,
  .sidebar-container,
  .canvas-area,
  .sidebar-content {
    height: 100% !important;
  }

  .book-center-right {
    overflow-y: hidden;
  }

  .page-controls,
  .header-container {
    height: auto !important;
  }

  .page-controls {
    margin: 16px 0 !important;
  }
}
</style>